import { Layout, SaveButton, SlideoutDecorator, SlideoutDecoratorProps } from "@mcleod/components";

export class MenuActionSlideout {


    public static async showAddBranchSlideout(props?: Partial<SlideoutDecoratorProps>): Promise<boolean> {
        return this.showSlideout("common/menueditor/AddMenuBranch", props);
    }

    public static async showMenuItemEditorSlideout( props?: Partial<SlideoutDecoratorProps>): Promise<boolean> {
        return this.showSlideout("common/menueditor/MenuItemEditor", props);
    }

    private static async showSlideout(layoutPath: string, props: Partial<SlideoutDecoratorProps>): Promise<boolean> {
        const layout = Layout.getLayout(layoutPath, {padding: 12});
        return new Promise<boolean>((resolve) => {
            const sld = new SlideoutDecorator({
                ...props,
                addlComponents: [
                    SaveButton.create({
                        rowBreak: false,
                        onClick: () => {
                            if (sld.layout.validateSimple()) {
                                sld.onClose(false);
                            }
                        }
                    })
                ],
                layout: layout,
                width: 1000,
                fillVerticalSpace: true,
                backgroundColor: "defaultBackground",
                overlayProps: {
                    closeOnClickOff: false,
                    greyedBackground: true,
                }
            });
            sld.onClose = (cancelled: boolean) => {
                sld.slideOut().then(() => {
                    resolve(cancelled !== true);
                });
            };
        });
    }
}
